import * as React from 'react';
import LoadingBars from '@reverbdotcom/discovery-ui/dist/components/loading_bars';
import ErrorMessage from './error_message';

function Loading(props) {
  if (!props.loaded) {
    return (
      <div className="scaling-mtb-2 d-flex fx-justify-center">
        <LoadingBars />
      </div>
    );
  }

  if (props.hasError) { return <ErrorMessage message={props.errorMessage} />; }

  return <div className="loaded-component">{props.children}</div>;
}

export default Loading;



// WEBPACK FOOTER //
// ./javascripts/components/shared/loading.jsx